export enum WebSymptomEventDetailsParamKey {
  REDIRECT_TO_MONITORING = 'redirectToMonitoring',
}
